import React, { useEffect, useMemo, useRef, useState } from "react";
import Checkbox from "@mui/material/Checkbox";
import ReusableGrid from "../../../components/ag grid/ReusableGrid";
import { Paper, Typography, Popper } from "@mui/material";

const ChallansTab = ({ challans, selectedChallan, setSelectedChallan }) => {
  const gridRef = useRef();
  const isMobile = window.innerWidth < 600;
  const [gridHeight, setGridHeight] = useState(300);

  const [anchorEl, setAnchorEl] = useState(null);
  const [description, setDescription] = useState("");
  const [isHoveringPopper, setIsHoveringPopper] = useState(false);
  const timeoutRef = useRef(null);
  const modalRef = useRef(null);

  // calculate grid height dynamically
  useEffect(() => {
    const calculateHeight = () => {
      const windowHeight = window.innerHeight;
      const offset = 280;
      setGridHeight(windowHeight - offset);
    };
    calculateHeight();
    window.addEventListener("resize", calculateHeight);
    return () => window.removeEventListener("resize", calculateHeight);
  }, []);

  const handleChallanToggle = (challanObj, checked) => {
    const isSelected = selectedChallan.some((c) => c.id === challanObj.id);
    const updated = checked
      ? [...selectedChallan, challanObj]
      : selectedChallan.filter((c) => c.id !== challanObj.id);
    setSelectedChallan(updated);
  };

  const handleMouseEnter = (event, desc) => {
    clearTimeout(timeoutRef.current);
    setAnchorEl(event.currentTarget);
    setDescription(desc);
  };

  const handleMouseLeave = () => {
    timeoutRef.current = setTimeout(() => {
      if (!isHoveringPopper) {
        setAnchorEl(null);
        setDescription("");
      }
    }, 100);
  };

  // column definitions
  const columnDefs = useMemo(() => {
    return [
      {
        headerName: "Select",
        field: "select",
        width: 100,
        pinned: "left",
        cellRenderer: (params) => (
          <Checkbox
            checked={selectedChallan.some((c) => c.id === params.data.id)}
            onChange={(e) => handleChallanToggle(params.data, e.target.checked)}
          />
        ),
      },
      {
        headerName: "Name",
        field: "name",
        minWidth: isMobile ? 250 : 400, // ⬅️ wider to prevent cutting
        flex: 2,
        autoHeight: true,
        cellRenderer: (params) => (
          <Typography
            onMouseEnter={(e) => handleMouseEnter(e, params.data.description)}
            onMouseLeave={handleMouseLeave}
            sx={{
              cursor: "pointer",
              color: "blue",
              whiteSpace: "normal", // ⬅️ allow wrapping instead of cut
              wordBreak: "break-word",
            }}
          >
            {params.data.name}
          </Typography>
        ),
      },
      {
        headerName: "Percentage",
        field: "percentage",
        minWidth: 150, // ⬅️ extra width
        flex: 1,
        valueFormatter: (params) => `${params.value || 0}%`,
      },
      {
        headerName: "Amount",
        field: "amount",
        minWidth: 150,
        flex: 1,
        valueFormatter: (params) => params.value || 0,
      },
    ];
  }, [challans, selectedChallan, isMobile]);

  return (
    <div style={{ overflowX: "auto", width: "100%" }} ref={modalRef}>
      <ReusableGrid
        rowData={challans}
        columnDefs={columnDefs}
        pagination={false}
        gridRef={gridRef}
        domLayout="normal"
        height={`${gridHeight}px`}
      />

      <Popper
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        placement="right-start"
        container={modalRef.current}
        style={{ zIndex: 1300 }}
        modifiers={[
          {
            name: "preventOverflow",
            options: {
              boundary: modalRef.current,
            },
          },
        ]}
      >
        <Paper
          onMouseEnter={() => setIsHoveringPopper(true)}
          onMouseLeave={() => {
            setIsHoveringPopper(false);
            setAnchorEl(null);
            setDescription("");
          }}
          sx={{
            padding: 1.5,
            maxWidth: 350,
            maxHeight: 200,
            overflow: "auto",
            backgroundColor: "#f8f9fa",
            boxShadow: 3,
            "& h2": { fontSize: "16px", margin: 0, padding: 0 },
            "& li": { fontSize: "14px", marginBottom: "6px" },
          }}
        >
          <div dangerouslySetInnerHTML={{ __html: description }} />
        </Paper>
      </Popper>
    </div>
  );
};

export default ChallansTab;









// import React, { useState, useRef } from "react";
// import {
//   Box,
//   Typography,
//   Table,
//   TableHead,
//   TableRow,
//   TableCell,
//   TableBody,
//   Checkbox,
//   TableContainer,
//   Paper,
//   Popper
// } from "@mui/material";

// const ChallansTab = ({ challans, selectedChallan, setSelectedChallan }) => {
//   const [anchorEl, setAnchorEl] = useState(null);
//   const [description, setDescription] = useState("");
//   const [isHoveringPopper, setIsHoveringPopper] = useState(false);
//   const modalRef = useRef(null);
//   const timeoutRef = useRef(null);

//   const handleChallanToggle = (challanObj) => {
//     const isSelected = selectedChallan.some((c) => c.id === challanObj.id);
//     const updated = isSelected
//       ? selectedChallan.filter((c) => c.id !== challanObj.id)
//       : [...selectedChallan, challanObj];
//     setSelectedChallan(updated);
//   };

//   const handleMouseEnter = (event, desc) => {
//     clearTimeout(timeoutRef.current);
//     setAnchorEl(event.currentTarget);
//     setDescription(desc);
//   };

//   const handleMouseLeave = () => {
//     timeoutRef.current = setTimeout(() => {
//       if (!isHoveringPopper) {
//         setAnchorEl(null);
//         setDescription("");
//       }
//     }, 100); // Delay to allow moving into popper
//   };

//   return (
//     <Box ref={modalRef}>
//       <TableContainer
//         component={Paper}
//         sx={{
//           maxHeight: 200,
//           overflow: "auto",
//           overflowX: "hidden",
//           border: "1px solid #ccc"
//         }}
//       >
//         <Table stickyHeader size="small">
//           <TableHead>
//             <TableRow>
//               <TableCell sx={{ borderRight: "1px solid #ccc" }}>Select</TableCell>
//               <TableCell sx={{ borderRight: "1px solid #ccc" }}>Name</TableCell>
//               <TableCell sx={{ borderRight: "1px solid #ccc" }}>Percentage</TableCell>
//               <TableCell>Amount</TableCell>
//             </TableRow>
//           </TableHead>
//           <TableBody>
//             {challans.map((ch) => (
//               <TableRow key={ch.id}>
//                 <TableCell sx={{ borderRight: "1px solid #ccc" }}>
//                   <Checkbox
//                     checked={selectedChallan.some((c) => c.id === ch.id)}
//                     onChange={() => handleChallanToggle(ch)}
//                   />
//                 </TableCell>
//                 <TableCell sx={{ borderRight: "1px solid #ccc" }}>
//                   <Typography
//                     onMouseEnter={(e) => handleMouseEnter(e, ch.description)}
//                     onMouseLeave={handleMouseLeave}
//                     sx={{ cursor: "pointer", color: "blue", display: "inline-block" }}
//                   >
//                     {ch.name}
//                   </Typography>
//                 </TableCell>
//                 <TableCell sx={{ borderRight: "1px solid #ccc" }}>
//                   {ch.percentage||0}%
//                 </TableCell>
//                 <TableCell>{ch.amount||0}</TableCell>
//               </TableRow>
//             ))}
//           </TableBody>
//         </Table>
//       </TableContainer>

//       <Popper
//         open={Boolean(anchorEl)}
//         anchorEl={anchorEl}
//         placement="right-start"
//         container={modalRef.current}
//         style={{ zIndex: 1300 }}
//         modifiers={[
//           {
//             name: "preventOverflow",
//             options: {
//               boundary: modalRef.current
//             }
//           }
//         ]}
//       >
//        <Paper
//         onMouseEnter={() => setIsHoveringPopper(true)}
//         onMouseLeave={() => {
//           setIsHoveringPopper(false);
//           setAnchorEl(null);
//           setDescription("");
//         }}
//         sx={{
//           padding: 1,
//           maxWidth: 350,
//           maxHeight: 200,
//           overflow: "auto",
//           backgroundColor: "#f8f9fa",
//           boxShadow: 3,
   
//           "& h2": {
//             color: "#000",
//             fontSize: "16px",
//             margin: 0,
//             padding: 0,
//           },
//           "& ol": {
//             paddingLeft: "16px",
//             marginTop: "4px",
//           },
//           "& li": {
//             color: "#6c757d",
//             fontSize: "14px",
//             marginBottom: "6px",
//           },
//         }}
//       >
//         <div dangerouslySetInnerHTML={{ __html: description }} />
//       </Paper>

//       </Popper>
//     </Box>
//   );
// };

// export default ChallansTab;
